import React from 'react';
import ErrorLayout from '../../components/ErrorLayout';

const NotFound = () => (
  <ErrorLayout 
    code={404} 
    title="Page Not Found" 
    message="Oops! The page you are looking for does not exist or has been moved." 
    icon="pi pi-search" 
    color="#3498db" 
  />
);
export default NotFound;